module.exports = __webpack_public_path__ + "Roboto-Bold.c8bcb1cb78f9e45e2bcb.eot";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Bold.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.eot
// module chunks = 16